export const REMOTE_SESSION_URL_PLACEHOLDER = '[ACTIVATION_LINK]';
export const SALESFORCE_ACCOUNT_ID_APPKEY = 'salesforceId';

//These keys are valid for DB config in neuro
export const VALID_DB_ATTRIBUTE_KEYS = [
  'customConfigs',
  'deepLinking',
  'errorValidations',
  'isDialogue',
  'salesforceConfig',
  'uiConfig',
  'urlParamAnswers'
];

//These keys are valid for the init function call of neuro app
export const VALID_APP_CONFIG_KEYS = [
  ...VALID_DB_ATTRIBUTE_KEYS,
  'customMessages',
  'htmlMessageValues',
  'isDemoMode',
  'uiBreakpoints',
  'urlParamAnswers',
  'questionLayouts',
  'questionTypes'
];

export const DEFAULT_CHART_COLORS = [
  'hsl(45, 70%, 50%)',  // Gold
  'hsl(82, 70%, 50%)',  // Green
  'hsl(208, 70%, 50%)', // Blue
  'hsl(351, 70%, 50%)', // Red
  'hsl(274, 70%, 50%)'  // Purple
];
